import { useQuery } from "@tanstack/react-query";
import { AgentSummary } from "@/model";
import deploymentRepository from "@/repository/deploymentRepository";
import { deploymentQueryKeys } from "./keys";


const getData = async (id: number) => {
    const res = await deploymentRepository.getAgentSummary(id);
    return res.data.data;
};

export const useAgentSummary = (agentId: number) => {
    return useQuery<AgentSummary>({
        queryKey: deploymentQueryKeys.agentSummary(agentId),
        queryFn: async () => getData(agentId),
        retry: false
    });
};
